import axiosAuth from '../../axiosMain';

async function update(id, data) {
  let response = await axiosAuth.post('/energy_suppliers/assign/' + id, data);
  return response.data.data;
}

async function show(id) {
  let response = await axiosAuth.get('/energy_suppliers/assign/' + id);
  return response.data.data;
}

export default {
  update,
  show,
};
